export const CHANGE_RESULTS_VIEW = 'CHANGE_RESULTS_VIEW';
export function changeResultsView(view) {
  return {
    type: CHANGE_RESULTS_VIEW,
    view: view,
  };
}

export const TOGGLE_MAP_SUMMARY_LIST = 'TOGGLE_MAP_SUMMARY_LIST';
export function toggleMapSummaryList() {
  return {
    type: TOGGLE_MAP_SUMMARY_LIST,
  };
}

export const DETAIL_VIEW_OPEN = 'DETAIL_VIEW_OPEN';
export function detailViewOpen(open) {
  return {
    type: DETAIL_VIEW_OPEN,
    open: open,
  };
}
